module.exports = __webpack_public_path__ + "media/src/img/payment/kseniya_sber_qr-686aac6b9af93a0c5e275d471d875954.png";